<div class="row text-center animated fadIn">
  <div class="col">
      <i class="fas fa-spinner fa-pulse fa-2x"></i>
  </div>
</div>
